import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PEV } from "../../../../../../common/utils";
import * as service from "./service";

const emptyReviewHistory = () => ({
  data: PEV({
    columns: [],
    dataSource: [],
  }),
  openActiveReview: false,
  appId: null,
});

const initialState = {
  reviewHistory: [],
};

const getReviewHistory = createAsyncThunk("applications/review", async (appId) => {
  return await service.getReviewHistory(appId);
});

const findReviewIndexByAppId = (state, appId) =>
  state.reviewHistory.findIndex((rh) => rh.appId === appId);

export const ReviewHistorySlice = createSlice({
  name: "reviewHistory",
  initialState,
  reducers: {
    enableOpenActiveReview(state, action) {
      const { appId, enable } = action.payload;
      const reviewIndex = findReviewIndexByAppId(state, appId);
      state.reviewHistory[reviewIndex].openActiveReview = enable;
    },
    resetReviewHistory(state) {
      state.reviewHistory = initialState.reviewHistory;
    },
    createReviewHistoryIfNotExists(state, action) {
      const { appId } = action.payload
      const reviewIndex = findReviewIndexByAppId(state, appId);
      const emptyReview = { ...emptyReviewHistory(), appId };
      if (reviewIndex === -1) {
        state.reviewHistory.push(emptyReview);
      } 
    }
  },
  extraReducers: {
    [getReviewHistory.pending.type]: (state, pendingAction) => {
      const appId = pendingAction.meta.arg;
      const reviewIndex = findReviewIndexByAppId(state, appId);
      const emptyReview = { ...emptyReviewHistory(), appId };
      emptyReview.data.progress = "Fetching reviews";
      if (reviewIndex === -1) {
        state.reviewHistory.push(emptyReview);
      } else {
        state.reviewHistory[reviewIndex] = {
          ...emptyReview,
          openActiveReview: state.reviewHistory[reviewIndex].openActiveReview,
        };
      }
    },
    [getReviewHistory.fulfilled.type]: (state, action) => {
      const appId = action.meta.arg;
      const reviewIndex = findReviewIndexByAppId(state, appId);
      const emptyReview = { ...emptyReviewHistory(), appId, data: PEV(action.payload) };
      if (reviewIndex === -1) {
        state.reviewHistory.push(emptyReview);
      } else {
        state.reviewHistory[reviewIndex].data = PEV(action.payload);
      }
    },
    [getReviewHistory.rejected.type]: (state, rejectedAction) => {
      const appId = rejectedAction.meta.arg;
      const reviewIndex = findReviewIndexByAppId(state, appId);
      state.reviewHistory[reviewIndex].data.progress = null;
      state.reviewHistory[reviewIndex].data.error = rejectedAction.error;
    },
  },
});

export const isActiveReview = (status) => status === "In Progress";
export const isCancelledReview = (status) => status === "Canceled";
export const findReviewHistoryByAppId = (state, appId) =>
  state.reviewHistory.find((rh) => rh.appId === appId);
export const findAllReviewsByAppId = (state, appId) =>
  findReviewHistoryByAppId(state, appId)?.data?.value?.dataSource;

export const AppReviewReducer = ReviewHistorySlice.reducer;
const { enableOpenActiveReview, resetReviewHistory, createReviewHistoryIfNotExists } =
  ReviewHistorySlice.actions;

export const AppReviewActions = {
  getReviewHistory,
  enableOpenActiveReview,
  resetReviewHistory,
  createReviewHistoryIfNotExists,
};
